export default "__VITE_ASSET__vfWoC7So__"